import React from 'react';
import Loading from './Loading';
import { Route, Routes } from 'react-router-dom';
import SelectArea from './SelectArea';

const AdminCenter = React.lazy(() => import('./AdminCenter'));

export default function AdminCenterLoader() {
    return (
        <>
            <Loading />
            <Routes>
                <Route path="/" element={<SelectArea />} />
                <Route path="/:areaCode/*" element={<AdminCenter />} />
            </Routes>
        </>
    );
}
